<template>
  <el-dialog
    title="收件人修改"
    :visible.sync="visible"
    width="600px"
    center
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <el-form label-width="100px" :model="receiveForm" ref="editForm" :rules="rules">
      <el-form-item label="收件人姓名" prop="name">
        <el-input placeholder="请输入" class="y-w-400" v-model.trim="receiveForm.name" :maxlength="12"></el-input>
      </el-form-item>
      <el-form-item ref="mobile" label="手机号码" prop="mobile">
        <el-input placeholder="请输入" class="y-w-400" v-model.trim="receiveForm.mobile" :maxlength="11"></el-input>
      </el-form-item>
      <el-form-item label="省市区" prop="district">
        <el-select class="y-w-120 y-mr-20" v-model="receiveForm.provinceId" filterable placeholder="请选择省" clearable @change="handleChangeProvice">
          <el-option
            v-for="item in provinceList"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select class="y-w-120 y-mr-20" v-model="receiveForm.cityId" filterable placeholder="请选择市" clearable @change="handleChangeCity">
          <el-option
            v-for="item in cityList"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select class="y-w-120" filterable placeholder="请选择区" clearable @change="handleChangeDistrict" v-model="receiveForm.districtId">
          <el-option
            v-for="item in districtList"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="详细地址" prop="addressDetail">
        <el-input placeholder="请输入" class="y-w-400" v-model.trim="receiveForm.addressDetail" :maxlength="64"></el-input>
      </el-form-item>
      <div class="tipStyle">注意：已打印的订单修改收件人信息后只能用新单号打印</div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="saveInfo">保存</el-button>
      <el-button @click="visible = fasle">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getDistrictApi } from '@/api/universal';
export default {
  props: ['fromParentVisible'],
  watch: {
    visible(val) {
      this.$emit('update:fromParentVisible', val)
    }
  },
  data() {
    let specStr = (rule, value, callback) => {
      if (
        !/^[\u4e00-\u9fa5_a-zA-Z0-9+*/=\-,.!?:;'"()，。！？：；‘’“”（）+-~<>《》#\s]*$/.test(
          value
        )
      ) {
        callback(new Error('不能包含特殊字符！'));
      } else {
        callback();
      }
    };
    let valiMobile = (rule, value, callback) => {
      if (!(/(^1\d{10}$)/.test(value) || /(^([5|6|9])\d{7}$)/.test(value)) && value !== '') {
        return callback(new Error('手机号格式不正确'));
      } else {
        callback();
      }
    };
    let validateDistrictRecive = (rule, value, callback) => {
      this.$nextTick(() => {
        if (this.receiveForm.provinceId && this.receiveForm.cityId && this.receiveForm.districtId) {
          callback();
        } else {
          callback(new Error('请选择完整的省市区'));
        }
      });
    };
    return {
      receiveForm: {
        name: '',
        mobile: '', // 手机号
        provinceId: '', // 省区编码
        provinceName: '',
        cityId: '', // 城市编码
        cityName: '',
        districtId: '', // 区编码
        districtName: '',
        addressDetail: '', // 详细地址
      },
      provinceList: [], // 省区列表
      cityList: [], // 城市列表
      districtList: [], // 区列表
      visible: true,
      rules: {
        name: [
          { required: true, message: '不能为空', trigger: ['change', 'blur'] },
          { validator: specStr, trigger: ['change', 'blur'] }
        ],
        mobile: [
          { required: true, message: '不能为空', trigger: ['change', 'blur'] },
          { validator: valiMobile, trigger: ['blur', 'change'] }
        ],
        district: [{ required: true, validator: validateDistrictRecive, trigger: 'change' }],
        addressDetail: [
          { required: true, message: '不能为空', trigger: ['change', 'blur'] },
          { validator: specStr, trigger: ['change', 'blur'] }
        ]
      },
    };
  },
  mounted() {
    this.getProvinceList();
  },
  methods: {
    getProvinceList() {
      // 获取省份列表
      let params = {
        parentCode: '086'
      }
      getDistrictApi(params).then(res => {
        this.provinceList = res;
      })
    },
    handleChangeProvice(val) {
      // 改变省份
      this.receiveForm.provinceName = this.provinceList.filter(item => item.value === val)[0].name;
      this.receiveForm.cityId = ''; // 重置
      this.receiveForm.districtId = ''; // 重置
      let params = {
        parentCode: val
      }
      getDistrictApi(params).then(res => {
        this.cityList = res;
      })
    },
    handleChangeCity(val) {
      // 改变城市
      this.receiveForm.cityName = this.cityList.filter(item => item.value === val)[0].name;
      this.receiveForm.districtId = ''; // 重置
      let params = {
        parentCode: val
      }
      getDistrictApi(params).then(res => {
        this.districtList = res;
      })
    },
    handleChangeDistrict(val) {
      // 改变区
      this.receiveForm.districtName = this.districtList.filter(item => item.value === val)[0].name;
    },
    saveInfo() {
      this.$refs['editForm'].validate(valid => {
        if (valid) {
          console.log(this.receiveForm)
          this.$emit('saveInfo', this.receiveForm);
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
.tipStyle {
  font-size: 12px;
  color: #999;
  text-align: center;
}
</style>
